<template>
  <div class="editor-container">
    <div v-if="editor">
      <button
        data-test-id="button-editor-bold"
        class="btn btn-sm btn-default"
        :disabled="!editor.can().chain().focus().toggleBold().run()"
        :class="{ active: editor.isActive('bold') }"
        @click="editor.chain().focus().toggleBold().run()"
      >
        <span class="fa fa-bold"></span>
      </button>
      <button
        data-test-id="button-editor-italic"
        class="btn btn-sm btn-default"
        :disabled="!editor.can().chain().focus().toggleItalic().run()"
        :class="{ active: editor.isActive('italic') }"
        @click="editor.chain().focus().toggleItalic().run()"
      >
        <span class="fa fa-italic"></span>
      </button>
      <button
        data-test-id="button-editor-strike"
        class="btn btn-sm btn-default"
        :disabled="!editor.can().chain().focus().toggleStrike().run()"
        :class="{ active: editor.isActive('strike') }"
        @click="editor.chain().focus().toggleStrike().run()"
      >
        <span class="fa fa-strikethrough"></span>
      </button>
      <button
        data-test-id="button-editor-code"
        class="btn btn-sm btn-default"
        :disabled="!editor.can().chain().focus().toggleCode().run()"
        :class="{ active: editor.isActive('code') }"
        @click="editor.chain().focus().toggleCode().run()"
      >
        T
      </button>
      <button
        data-test-id="button-editor-paragraph"
        class="btn btn-sm btn-default"
        :class="{ active: editor.isActive('paragraph') }"
        @click="editor.chain().focus().setParagraph().run()"
      >
        P
      </button>
      <button
        data-test-id="button-editor-h1"
        class="btn btn-sm btn-default"
        :class="{ active: editor.isActive('heading', { level: 1 }) }"
        @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
      >
        H1
      </button>
      <button
        data-test-id="button-editor-h2"
        class="btn btn-sm btn-default"
        :class="{ active: editor.isActive('heading', { level: 2 }) }"
        @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
      >
        H2
      </button>
      <button
        data-test-id="button-editor-h3"
        class="btn btn-sm btn-default"
        :class="{ active: editor.isActive('heading', { level: 3 }) }"
        @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
      >
        H3
      </button>
      <button
        data-test-id="button-editor-bullet-list"
        class="btn btn-sm btn-default"
        :class="{ active: editor.isActive('bulletList') }"
        @click="editor.chain().focus().toggleBulletList().run()"
      >
        <span class="fa fa-list-ul"></span>
      </button>
      <button
        data-test-id="button-editor-ordered-list"
        class="btn btn-sm btn-default"
        :class="{ active: editor.isActive('orderedList') }"
        @click="editor.chain().focus().toggleOrderedList().run()"
      >
        <span class="fa fa-list-ol"></span>
      </button>
      <button
        data-test-id="button-editor-code-block"
        class="btn btn-sm btn-default"
        :class="{ active: editor.isActive('codeBlock') }"
        @click="editor.chain().focus().toggleCodeBlock().run()"
      >
        <span class="fa fa-code"></span>
      </button>
      <button
        data-test-id="button-editor-blockquote"
        class="btn btn-sm btn-default"
        :class="{ active: editor.isActive('blockquote') }"
        @click="editor.chain().focus().toggleBlockquote().run()"
      >
        <span class="fa fa-quote-left"></span>
      </button>
      <button
        data-test-id="button-editor-horizontal-rule"
        class="btn btn-sm btn-default"
        @click="editor.chain().focus().setHorizontalRule().run()"
      >
        HR
      </button>
      <button
        data-test-id="button-editor-undo"
        class="btn btn-sm btn-default"
        :disabled="!editor.can().chain().focus().undo().run()"
        @click="editor.chain().focus().undo().run()"
      >
        <span class="fa fa-undo"></span>
      </button>
      <button
        data-test-id="button-editor-redo"
        class="btn btn-sm btn-default"
        :disabled="!editor.can().chain().focus().redo().run()"
        @click="editor.chain().focus().redo().run()"
      >
        <span class="fa fa-repeat"></span>
      </button>
    </div>
    <EditorContent :editor="editor" />
  </div>
</template>

<script>
import StarterKit from '@tiptap/starter-kit'
import { Editor, EditorContent } from '@tiptap/vue-3'

export default {
  components: {
    EditorContent,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      editor: null,
    }
  },

  watch: {
    value(value) {
      // HTML
      const isSame = this.editor.getHTML() === value

      // JSON
      // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

      if (isSame) {
        return
      }

      this.editor.commands.setContent(value, false)
    },
  },

  mounted() {
    this.editor = new Editor({
      content: this.value,
      extensions: [StarterKit],
      onUpdate: () => {
        // HTML
        this.$emit('input', this.editor.getHTML())

        // JSON
        // this.$emit('input', this.editor.getJSON())
      },
    })
  },

  beforeDestroy() {
    this.editor.destroy()
  },
}
</script>

<style>
.editor-container {
  display: block;
  width: 100%;
  height: auto;
  background-color: white;
  background-image: none;
  border: 2px solid #dce4ec;
  border-radius: 2px;
  box-shadow: none;
}

.editor-container .ProseMirror {
  padding: 10px 15px;
  font-size: 12px;
  line-height: 1.428;
  color: black;
  outline: none;
}
</style>
